<template>
  <div class="ApplicationList grey lighten-6">
    <div>
      <ScoutNotification
        v-if="showScoutNotification"
        class="ieWarning  mt-6 mx-12"
        cog="false"
      />
    </div>
    <v-row class="application-filter mt-6 ml-8">
      <v-col cols="auto" class="IE-FlexAuto">
        <ApplicationFilter
          v-model="selectedApplication"
          :items="filters"
          :total-applications="totalApplicationsDisplayed"
        />
      </v-col>
    </v-row>
    <div
      v-if="
        selectedApplication === 'New' || selectedApplication === 'Completed'  || selectedApplication === 'Assigned'
      " >
      <EADataTable
        :mode="selectedApplication"
        @switch-filter="
          selectedApplication =
            selectedApplication === 'Completed' ? 'Completed' : selectedApplication === 'Assigned'? 'Assigned' : 'New'
        "
      />
    </div>
  </div>
</template>

<script>

import ApplicationFilter from '@/components/applicationList/Filter.vue'
import EADataTable from './EaDataTable'
import { mapGetters } from 'vuex'
import { EA_CATEGORY } from '@/constants'
import ScoutNotification from '@/components/app/ScoutNotification'

const FILTERS = {
  new: {
    text: 'New Cases',
    value: EA_CATEGORY.NEW,
    icon: 'layers',
    size: '28',
    color: 'secondary'
  },
  assigned: {
    text: 'Assigned/Active Cases',
    value: EA_CATEGORY.ASSIGNED,
    icon: 'send',
    size: '32',
    color: 'success'
  },
  completed: {
    text: 'Completed Cases',
    value: EA_CATEGORY.COMPLETED,
    icon: 'layers',
    size: '32',
    color: 'success'
  }
}

export default {
  name: 'ApplicationList',
  components: {
    ApplicationFilter,
    EADataTable,
  },
  data() {
    return {
      selectedApplication: EA_CATEGORY.NEW
    }
  },
  watch: {
    // Change application filter on change 
    selectedApplication: {
      handler(newValue) {
        if (newValue) {
        
            this.$store.state.category = newValue;//.commit('set', ['selectedCategory', newValue])

            this.loading = true
              this.$store.dispatch('getEaApplications').finally(() => {
                this.loading = false               
              })
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      selectedCategory: 'selectedCategory',
      eaApplications: 'eaApplications'
    }),
    filters() {
      const filters = [FILTERS.new, FILTERS.assigned, FILTERS.completed]

      return filters
    },
    totalApplicationsDisplayed() {
      if (!this.selectedApplication) {
        return 0
      }
      return this.eaApplications(this.selectedApplication).length;       
    },
    showScoutNotification() {
      return false
    },
  }
}
</script>

<style scoped lang="scss">
.alert {
  color: $color-red;
}
.application-filter {
  position: absolute;
  z-index: 1;
}
</style>
